import styled from '@emotion/styled'
import WhiteButton from '@organisms/WhiteButton'

export const XlsFinalTestModalFrame = styled.div`
  .xls-final-test-modal {
    width: min(1188px, calc(100vw - 90px));
    max-width: min(1188px, calc(100vw - 90px));
    min-width: 0;
    box-sizing: border-box;
  }

  .xls-final-test-modal h1,
  .xls-final-test-modal h2 {
    margin: 0;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: 0;
    white-space: normal;
  }

  .xls-final-test-modal #contentFields > div > div {
    gap: 14px;
  }

  .xls-final-test-modal #contentFields label {
    padding-top: 0;
  }

  .xls-final-test-modal #contentFields label:nth-of-type(1) {
    width: 260px;
  }

  .xls-final-test-modal #contentFields label:nth-of-type(2) {
    width: 226px;
  }

  .xls-final-test-modal #contentFields label:nth-of-type(3) {
    width: 306px;
  }

  .xls-final-test-modal #contentFields label:nth-of-type(4) {
    width: 178px;
  }

  .xls-final-test-modal #contentFields label > div:first-of-type {
    height: 30px;
    white-space: nowrap;
  }

  .xls-final-test-modal #contentFields input {
    height: 40px;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 20px;
  }

  .xls-final-test-modal #xls-final-test-file button {
    width: 260px;
    min-width: 260px;
    justify-content: flex-start;
    border: 1px solid #1d4e89;
    background: #1d4e89;
    color: #ffffff;
  }

  .xls-final-test-modal #xls-final-test-file button:hover {
    background: #1d4e89;
    color: #ffffff;
    box-shadow: none;
  }

  .xls-final-test-modal #xls-final-test-file button > span,
  .xls-final-test-modal #xls-final-test-file button > span + span {
    justify-content: flex-start;
    color: #ffffff;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  @media (max-width: 900px) {
    .xls-final-test-modal {
      width: min(100%, calc(100vw - 34px));
      max-width: calc(100vw - 34px);
    }

    .xls-final-test-modal #contentFields > div > div {
      flex-direction: column;
      gap: 12px;
    }

    .xls-final-test-modal #contentFields label,
    .xls-final-test-modal #contentFields label:nth-of-type(1),
    .xls-final-test-modal #contentFields label:nth-of-type(2),
    .xls-final-test-modal #contentFields label:nth-of-type(3),
    .xls-final-test-modal #contentFields label:nth-of-type(4) {
      width: 100%;
    }

    .xls-final-test-modal #contentFields label > div:first-of-type {
      height: auto;
      white-space: normal;
    }
  }
`

export const InfoBlock = styled.div`
  background: #eef2f8;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const InfoText = styled.div`
  font-size: 14px;
  line-height: 1.5;
`

export const TemplateDownloadButton = styled(WhiteButton)`
  width: 150px;
  min-width: 150px;
  height: 40px;
  justify-content: center;
  align-self: flex-start;
  border: 1px solid #1d4e89;
  background: #eef2f8;
  color: #000;

  &:hover,
  &:active,
  &:focus-visible {
    border-color: #1d4e89;
    background: #eef2f8;
    color: #000;
    box-shadow: none;
  }

  span {
    color: #000;
  }
`

export const InstructionList = styled.ul`
  margin: 0;
  padding: 0 0 0 20px;
  font-size: 14px;
  line-height: 1.5;
  color: inherit;

  li {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`
